import { TicketSource } from "shared/types/helpdesk";

export const getSourceColor = (source: TicketSource): string => {
  const colors: Record<TicketSource, string> = {
    [TicketSource.TENANT]: "bg-blue-100 text-blue-800 border-blue-300",
    [TicketSource.NEIGHBOUR]: "bg-orange-100 text-orange-800 border-orange-300",
    [TicketSource.INTERNAL]: "bg-green-100 text-green-800 border-green-300",
    [TicketSource.UNKNOWN]: "bg-neutral-secondary-mid/10 text-neutral-primary border-neutral-secondary-mid/30",
  };
  return colors[source] || "bg-neutral-secondary-mid/10 text-neutral-primary border-neutral-secondary-mid/30";
};